module.exports = __webpack_public_path__ + "img/img2.4693d009.jpg";